exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-element{display:inline-block;position:relative;overflow:hidden;opacity:0;z-index:1}.fade-element.no-overflow{overflow:visible}.fade-element.full-width{width:100%;height:100%}", ""]);

// exports
